import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../../styles/Inspire.scss";

gsap.registerPlugin(ScrollTrigger);

const TEXT = "Inspire";

const Inspire: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const lettersRef = useRef<HTMLSpanElement[]>([]);

  useEffect(() => {
    if (!sectionRef.current) return;

    const letters = lettersRef.current;

    // Initial folded state
    gsap.set(letters, {
      opacity: 0,
      rotateX: 160,
      y: 160,
      transformOrigin: "bottom center",
    });

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top 85%",      // 🔥 malapit bago gumalaw
      end: "top 35%",
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const direction = self.direction;

        gsap.to(letters, {
          opacity: progress,
          rotateX:
            direction === 1
              ? 120 * (1 - progress)
              : -120 * (1 - progress),
          y: (1 - progress) * (direction === 1 ? 120 : -120),
          stagger: {
            each: 0.08,
            from: direction === 1 ? "start" : "end",
          },
          ease: "none",
          overwrite: true,
        });
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <section className="inm-section" ref={sectionRef}>
      <div className="inm-content">
        <h1 className="inspire-title">
          {TEXT.split("").map((char, i) => (
            <span
              key={i}
              className="inspire-letter"
              ref={(el) => {
                if (el) lettersRef.current[i] = el;
              }}
            >
              {char}
            </span>
          ))}
        </h1>

        <p className="inspire-text">
          Because sucess isn't just a destination — it's a journey that never stops moving forward.
        </p>
      </div>
    </section>
  );
};

export default Inspire;
